import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SBrand } from './AuthLayoutHeader.styles';
import { PercapitaLogo } from '../../../PercapitaLogo/PercapitaLogo';

export const AuthLayoutHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleBrandClick = () => {
    navigate('/');
  };

  return (
    <SBrand onClick={handleBrandClick}>
      <PercapitaLogo isWhite />
    </SBrand>
  );
};
